import { SUPPORTED_TOKEN_CONTRACTS, SupportedTokenName } from "@mezo/sdk"

import { ETHEREUM_NETWORK } from "#/shared/constants"

import createDappAsyncThunk from "../asyncThunk"
import { setDepositFeeData } from "../slices/receipt-token"
import { setIsProcessingTransaction } from "../slices/wallet"

export const fetchFeeOwed = createDappAsyncThunk(
  "receipt-token/fetchFeeOwedForDeposit",
  async (
    depositId: number,
    { getState, dispatch, extra: { sdk } },
  ): Promise<void> => {
    const depositsFromStore = getState().portal.deposits

    const depositFromStore = depositsFromStore.find(
      (deposit) => deposit.depositId === depositId,
    )

    if (!depositFromStore) return

    const { address } = SUPPORTED_TOKEN_CONTRACTS[depositFromStore.token]

    const deposit = await sdk.mezo.chain?.depositModule.getDepositFromChain(
      address[ETHEREUM_NETWORK],
      BigInt(depositId),
    )

    if (deposit) {
      dispatch(
        setDepositFeeData({
          depositId,
          feeOwed: deposit.feeOwed,
          lastFeeIntegral: deposit.lastFeeIntegral,
        }),
      )
    }
  },
)

export const repayReceiptToken = createDappAsyncThunk(
  "receipt-token/repayReceiptToken",
  async (
    {
      depositUuid,
      amount,
      token,
      depositId,
    }: {
      depositUuid: string
      amount: bigint
      token: SupportedTokenName
      depositId: bigint
    },
    { getState, dispatch, extra: { sdk } },
  ): Promise<boolean> => {
    const { isConnected } = getState().wallet

    if (!isConnected) return false

    const { address, abi } = SUPPORTED_TOKEN_CONTRACTS[token]
    const tokenForDeposit = { address: address[ETHEREUM_NETWORK], abi }

    dispatch(setIsProcessingTransaction(true))

    const repayResult = await sdk.mezo.chain?.receiptTokenModule.repay(
      depositUuid,
      tokenForDeposit,
      depositId,
      amount,
    )

    dispatch(setIsProcessingTransaction(false))

    return !!repayResult
  },
)
